'use client'

import UIText from '@components/ui/UIText'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { DOMNode, Element, domToReact } from 'html-react-parser'
import ParticleImg from './Img'
import { Box } from '@mui/joy'
import UILink from '@components/ui/UILink'

interface ImageBoxProps {
	dom: Element
}
const ImageBox = ({ dom }: ImageBoxProps) => {
	const imageBox = dom.children.find(
		(children) => children instanceof Element && children.attribs?.class === 'image',
	) as Element
	const linkBox = imageBox.children.find(
		(children) => children instanceof Element && children.name === 'a',
	) as Element
	const image = (linkBox || imageBox).children.find(
		(children) => children instanceof Element && children.name === 'img',
	) as Element
	const caption = dom.children.find(
		(children) => children instanceof Element && children.attribs?.class === 'caption',
	) as Element
	return (
		image && (
			<Box
				className={dom.attribs.class.replace('photo_left', '').replace('photo_right', '')}
				component="figure"
				sx={{
					'&:after': { content: 'unset' },
					'&>*:not(:first-child)': {
						marginTop: pxToRem(12),
					},
				}}
			>
				{linkBox ? (
					<UILink href={linkBox.attribs.href} target={linkBox.attribs.target}>
						<ParticleImg dom={image} />
					</UILink>
				) : (
					<ParticleImg dom={image} />
				)}
				{caption?.children && (
					<UIText
						component="figcaption"
						level="Footnote"
						color={color.colGray5}
						fontWeight={500}
					>
						{domToReact(caption.children as Array<DOMNode>)}
					</UIText>
				)}
			</Box>
		)
	)
}

export default ImageBox
